'use client';

import styled from 'styled-components';
import { Carousel } from '@mantine/carousel';

import { breakpoints, colors } from '@/styles/theme';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const Lecturers = styled(Carousel)`
  width: 1232px;
  margin: 0 auto;

  @media (max-width: ${breakpoints.desktop}) {
    width: 816px;
  }
  @media (max-width: ${breakpoints.laptop}) {
    width: 100%;
  }
`;

export const ImageWrap = styled.div`
  width: 100%;
`;

export const Lecturer = styled.div`
  width: 400px;
  height: 225px;
  position: relative;
  margin-right: 16px;

  &:hover {
    ${ImageWrap} {
      filter: brightness(80%);
      transition: all 0.2s ease-in-out;
    }
  }
  @media (max-width: ${breakpoints.laptop}) {
    width: 100%;
    margin-right: 0;
  }
`;

export const ImageText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: absolute;
  bottom: 24px;
  left: 24px;
  color: ${colors.light};
  z-index: 4;
`;

export const Name = styled.div`
  font-size: 1.5rem;
  font-weight: bold;
`;

export const About = styled.div`
  font-weight: bold;
`;
